export default __webpack_public_path__ + "586c0d25d964dde0bc321792314659f6.png";